import React, { useState } from 'react';
import InverterWithAgilePriceList from "./InverterWithAgilePriceList"
import InverterAgilePriceChart from './InverterAgilePriceChart';
import InverterAgilePriceHistoryList from './InverterAgilePriceHistoryList';
function OctopusAgilePrice() {
    const [inverterSN, setInverterSN] = useState(null);

    return (
        <div style={{
            display: 'flex',
            width: '100%',
            height: '100%',
        }}>
            <div style={{
                flex: 1,
                border: '3px solid #eee',
                padding: "4px",
            }}>
                <InverterWithAgilePriceList onInverterSelect={(inverterSN) => {setInverterSN(inverterSN)}} style={{}}/>
            </div>
            <div style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
            }}>
                <div style={{
                    flex: '0 0 250px',
                    border: '3px solid #eee',
                    padding: "4px",
                }}>
                    <InverterAgilePriceChart inverterSN={inverterSN} />
                </div>
                <div style={{
                    flex: "auto",
                    border: '3px solid #eee',
                    padding: "4px",
                }}>
                    <InverterAgilePriceHistoryList style={{}}/>
                </div>
            </div>
        </div>
    );
}

export default OctopusAgilePrice;
